// General dependencies
import _ from '@centerhealth/common/lodash';

// List of params we want to encode
export const KEY_MAP = {
  promo: 'pr',
  redirect: 'r',
  successMsg: 'scmsg',
  plan: 'pl',
  inv_email: 'inv_em',
};

export const KEY_DECODE_MAP = _.invert(KEY_MAP);

export const FB_SALT = 'b00 n07 c001';
